/**
 * Évaluation des dimensions de synthèse.
 *
 * Les libellés « favorable », « vigilance » et « alerte » se déduisent des
 * bornes déclarées dans `configuration.ts`. Aucune évaluation n'est écrite en
 * dur dans un gabarit (spécification § 6).
 */
import { SEUILS_EVALUATION } from './configuration.js';
/** Classement d'une valeur croissante : plus c'est haut, mieux c'est. */
export function classer(valeur, bornes) {
    if (valeur >= bornes.favorable)
        return 'favorable';
    if (valeur >= bornes.vigilance)
        return 'vigilance';
    return 'alerte';
}
export const evaluerCloture = (ecartFondsPropres) => classer(ecartFondsPropres, SEUILS_EVALUATION.cloture);
/**
 * Exécution : écart en points entre le taux d'encaissement des produits et le
 * taux de décaissement des charges à la date d'arrêté.
 */
export const evaluerExecution = (tauxProduits, tauxCharges) => classer((tauxProduits - tauxCharges) * 100, SEUILS_EVALUATION.execution);
export const evaluerAppelCotisations = (ratioAnneePrecedente) => classer(ratioAnneePrecedente, SEUILS_EVALUATION.appelCotisations);
export const evaluerRessourcesConventionnelles = (tauxEncaisse) => classer(tauxEncaisse, SEUILS_EVALUATION.ressourcesConventionnelles);
export const evaluerResultatProjete = (ecart) => classer(ecart, SEUILS_EVALUATION.resultatProjete);
export const evaluerReserve = (multipleSeuil) => classer(multipleSeuil, SEUILS_EVALUATION.reserve);
/**
 * Évaluation d'une trajectoire. Une cible d'effectifs dépassant le multiple
 * déclaré du record historique de payeurs bascule la trajectoire en
 * « hypothèse haute », quel que soit son résultat financier : on ne présente
 * pas comme favorable une projection qu'aucune série n'étaye.
 */
export function evaluerTrajectoire(params) {
    const plafond = params.recordHistoriquePayeurs * SEUILS_EVALUATION.multipleRecordHistorique;
    if (params.cibleEffectifs > plafond)
        return 'hypothese_haute';
    const multiple = params.seuilFinal > 0 ? params.reserveFinale / params.seuilFinal : 0;
    return classer(multiple, SEUILS_EVALUATION.trajectoire);
}
/** Libellé français d'un niveau d'évaluation. */
export function libelleEvaluation(n) {
    switch (n) {
        case 'favorable':
            return 'Favorable';
        case 'vigilance':
            return 'Vigilance';
        case 'alerte':
            return 'Alerte';
        case 'hypothese_haute':
            return 'Hypothèse haute';
    }
}
//# sourceMappingURL=evaluation.js.map